// Exports
export default {
	"participantsSidebar": "participantsSidebar_xlzs7",
	"close": "close_Y6+Cv",
	"head": "head_JNyqa",
	"content": "content_0iUGJ",
	"footer": "footer_B9G4+",
	"moderationPopupButton": "moderationPopupButton_2Ivfi",
	"title": "title_akxf0",
	"participantsCount": "participantsCount_YQTiE",
	"hasNew": "hasNew_gXuFA",
	"accessLevelControl": "accessLevelControl_ebkDk",
	"inviteOrCopyFooter": "inviteOrCopyFooter_7Gbj-",
	"peersTabs": "peersTabs_eYuVh",
	"search": "search_j7c9C"
};
